import React, { useState, useRef, useCallback } from 'react';
import i18next from 'i18next';
import './index.scss';
import CreateUser from './create-user';
import UserList from './user-list';

const UserOnboarding = () => {
  const [users, setUsers] = useState([]);
  const refreshUserListRef = useRef(null);

  const handleCreateUser = useCallback(() => {
    // Trigger refresh of user list after creation
    if (refreshUserListRef.current) {
      refreshUserListRef.current();
    }
  }, []);

  const handleUserListMounted = useCallback((refreshFn) => {
    refreshUserListRef.current = refreshFn;
  }, []);

  return (
    <div className='user-management-container'>
      <h5>{i18next.t('DYNAMIC_FORM.USER_MANAGEMENT.TITLE')}</h5>
      <div className='create-user-section'>
        <CreateUser onCreate={handleCreateUser} />
      </div>
      <div className='user-list-section'>
        <UserList users={users} onUserCreated={handleUserListMounted} />
      </div>
    </div>
  );
};

export default UserOnboarding;
